import React from 'react';
import { FacilityOrderTemplateValidationModalTemplate } from 'themes/application/facility-order/components';
import { observer } from 'mobx-react';
import { FacilityOrderTemplateValidationModalViewStore } from 'application/facility-order/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new FacilityOrderTemplateValidationModalViewStore(rootStore, componentProps), 'facilityOrderTemplateValidationModalViewStore')
@observer
class FacilityOrderTemplateValidationModal extends React.Component {
    render() {
        return <FacilityOrderTemplateValidationModalTemplate {...this.props} />
    }
}

export default FacilityOrderTemplateValidationModal;